import PropTypes from "prop-types";
import CardTabs from "../../components/CardTabs";
import { CommonNavbar } from "../../components/CommonNavbar";
import FilterPopUp from "../../components/FilterPopUp";
import SuccessMessage from "../../components/SuccessMssgDisplay";
import { InvestigatorNameList } from "../AllottedCasesDetailsPage/InvestigatorNameList";
import { makeSelectCardCases } from "../SubmittedCases/selectors";
import { caseDetails } from "./actions";
import CaseCard from "./CaseCard";
import makeSelectSubmittedCasesDetailsPage from "./selectors";
import { createStructuredSelector } from "reselect";
import { connect } from "react-redux";
import { compose } from "redux";
import { memo, useContext, useEffect, useState ,useCallback} from "react";
import { useInjectReducer } from "../../utils/injectReducer";
import reducer from "./reducer";
import { vendorCardData } from "../../constants/submittedCasesTabConstants";
import { ApiDispatchContext } from "../../context/ApiContext";
import { getUrlParameter } from "../../constants/commonFunction";
import path from "../../constants/pathConstants";
import ErrorAlert from "../../components/ErrorAlert";


 function SubmittedCaseDetails({allCases, updateCaseDetails, setApiReRender }){
  useInjectReducer({ key: "submittedCasesDetailsPage", reducer });
  const [selectedValue, setSelectedValue] = useState();
  const [tabList, setTabList] = useState(vendorCardData);
  const api = useContext(ApiDispatchContext);
  const [modal, setModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalBody, setModalBody] = useState("");
  const [open, setOpen] = useState(false);
  const [tabVal, setTabVal] = useState("Investigation")
  const [vendorDetails, setVendorDetails] = useState({})
  const [showSuccessMessage, setShowSuccessMessage] = useState(null)
  const toggle = () => setModal(!modal);
  let caseid = Number(getUrlParameter('case'));
      useEffect(() => {
        window.scrollTo(0, 0);
        let param = {
          "caseType": "submitted",
        }
        api.getCasesDetails(param).then(data => {
          if (data.data && data.data.success) {
            selectedCard(data.data.data.rows)
          } else {
            setModalTitle("Error");
            if (data.data.error && data.data.message) {
              setModalBody(data.data.message)
            }
            else {
              setModalBody('Please try after sometime');
            }
            toggle();
          }
        }).catch(err => {
          setModalTitle("Error");
          if (err && err.response && err.response.data && err.response.data.message) {
            setModalBody(err.response.data.message);
          } else {
            setModalBody('Please try after sometime');
          }
          toggle();
        })
      }, []);

  const selectedCard = useCallback((cards) => {
    const selectedCase = cards.find(item => item.some(field => field.label === "Case No." && field.value === Number(getUrlParameter('case'))));
    setSelectedValue([selectedCase]);
    const lobType = selectedCase.find(item => item.label === "LOB") ?.value || "";
    if (lobType === "A&H") {
      const tabsToHide = ["Proposal", "Risk", "Endorsement", "Dispatch"];
      const filteredTabs = tabList?.filter(
        (tab) => !tabsToHide.includes(tab?.tabTitle)
  );
    setTabList(filteredTabs);
    }
    updateCaseDetails({ lob: selectedCase.find(item => item.label === "LOB") ?.value || ""})
  }, [tabList]);

  const filterToggle = () => {
    setOpen(!open);
  }

  const addInvestigatorHandler = async () => {
    let payload = {
      filters: {
        status: 'active'
      },
      page: 0,
      pageSize: 0,
      addInvestigators: true,
      caseId: caseid,
    }
    setOpen(true)
    await api.employeeDetails(payload).then(data => {
      if (data.data && data.data.success) {
        setVendorDetails(decryptData(data.data.data))
      }
      else {
        setModalTitle("Error");
        if (data.data.error && data.data.message) {
          setModalBody(data.data.message)
        }
        else {
          setModalBody('Please try after sometime');
        }
        toggle();
      }
    }).catch((err) => {
      setModalTitle("Error");
      if (err && err.response && err.response.data && err.response.data.message) {
        setModalBody(err.response.data.message);
      } else {
        setModalBody('Please try after sometime');
      }
      toggle();
    })
  }
  const assignInvestigatorHandler = (caseId, selectedEmpId) => {
    let param = {
      case_id: [Number(caseId)],
      assigned_to_investigator: selectedEmpId
    };
    api.assignInvestigator(param)
      .then((data) => {
        if (data ?.data ?.success) {
          setShowSuccessMessage(data.data.message);
          setApiReRender(true);
          filterToggle();
        }
      })
      .catch((err) => {
        console.error("Caught in catch block:", err);
        setModalTitle("Error");
        setModalBody(
          err ?.response ?.data ?.message || 'Please try after sometime'
      );
        toggle();
      });

  };
    return (
          <div className="submitted-cases-details-page">
      <CommonNavbar title="Submitted Cases" backButton={path.SUBMITTED_CASE} search={false} download={false} navbarname='AssignedBlocksAllottedCases' />
      <div style={{ marginTop: "20px" }}></div>
      <CaseCard selectCards={selectedValue} />
      <ErrorAlert
        modal={modal}
        toggle={toggle}
        modalTitle={modalTitle}
        modalBody={modalBody}
      />
      <CardTabs tabData={tabList} onTabChange={(tabTitle) => setTabVal(tabTitle)} />
      {open && (<FilterPopUp open={open} backgroundColor={'#8F949B80'} >
        <InvestigatorNameList onCancelHandler={() => filterToggle()} vendorDetails={vendorDetails} onAddHandler={(caseId, selectedEmpId) => assignInvestigatorHandler(caseId, selectedEmpId)} />
      </FilterPopUp>)}
      {showSuccessMessage && (
        <SuccessMessage message={showSuccessMessage} delay={3000} />
      )}
    </div >
    )
}

SubmittedCaseDetails.propTypes = {
  dispatch: PropTypes.func
};

export function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    updateCaseDetails: (data) => dispatch(caseDetails(data)),
  }
}

const mapStateToProps = createStructuredSelector({
  submittedCasesDetailsPage: makeSelectSubmittedCasesDetailsPage(),
  allCases: makeSelectCardCases()
});


const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps
);

export default compose(withConnect, memo)(SubmittedCaseDetails);